import { gql } from "@apollo/client";

// Count-only variant of SearchAssets (~0.2s even for large fleets). Used by the
// CSV export to know the size of the slow IoT pass up front, so the progress
// bar can span both passes instead of hitting 100% after the first one.
export const SearchAssetsTotal = gql`
    query SearchAssetsTotal (
        $filter: SearchAssetFilter
        $query: SearchAssetQuery
    ) {
        searchAssets(
            filter: $filter
            query: $query
        ) {
            total
        }
    }
`;
